import React from 'react'

const appData = {
  test: null,
}

export const AppContext = React.createContext(appData)

export const AppContextProvider = (props) => (
  <AppContext.Provider value={appData}>{props.children}</AppContext.Provider>
)
